import './MapTopBar.css';
import { useIsAbroad, useLayout, useRouteState, useUi } from '../../state/hooks';
import { Breadcrumbs } from './Breadcrumbs';
import { MapLegend } from './MapLegend';
import { MapModeBar } from './MapModeBar';

export interface MapTopBarProps {
  /** Altura do retângulo do mapa em px lógicos (o seletor de candidato nunca passa da base dele, AC-9.3-17). */
  mapHeight?: number;
}

/**
 * Barra do mapa (§9.3), na caixa `map-top` do AppShell (topo = y0 − 44, altura 32; no tablet, os 48 px do topo da
 * caixa do mapa): à esquerda as migalhas (com lugar em foco) e os modos (só Presidente, fora do Exterior e fora da
 * TV); à direita a legenda. Não existe em `flow` e `land` (AC-9.3-04). Com um `EventToast` visível, entra em `hush`
 * (opacidade 0, sem ponteiro, §10.7); na TV não entra. Faz parte do chunk `index` (aparece antes do mapa, DE-06).
 */
export function MapTopBar({ mapHeight }: MapTopBarProps) {
  const { mode } = useLayout();
  const route = useRouteState();
  const abroad = useIsAbroad();
  const ui = useUi();
  if (mode === 'flow' || mode === 'land') return null;
  const tv = mode === 'tv';
  const hush = !tv && ui.toast !== null;
  const crumbs = route.place.kind !== 'br';
  const modes = route.office === 'president' && !abroad && !tv;
  return (
    <div
      class={`map-top-bar${hush ? ' map-top-bar--hush' : ''}`}
      data-testid="map-top-bar"
      data-hush={hush ? '' : undefined}
    >
      <div class="map-top-bar__nav">
        {crumbs ? <Breadcrumbs inert={tv} /> : null}
        {modes ? <MapModeBar pickerMaxHeight={mapHeight === undefined ? undefined : mapHeight - 12} /> : null}
      </div>
      <MapLegend />
    </div>
  );
}
